import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Rolemanagement } from "./rolemanagement.model";
// import { Commonmaster } from "../../commonmasters/commonmaster.model";
import { DatePipe } from "@angular/common"

@Injectable({
  providedIn: 'root'
})
export class RolemanagementService {
  

  selectedRolemanagement: Rolemanagement;
  rolemanagementList: Rolemanagement[];
  // selectedCommonmaster : Commonmaster;
  // commonMastersList :Commonmaster[];

  constructor(private httpClient: HttpClient) { }

  getBaseUrl() {  
    return environment.baseUrl;
  }  

  FetchRolemanagementbyId(staff: Rolemanagement) {
    var body = staff;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Role/Fetch', body, { headers: headers });
  }


  IUDRolemanagement(rolemanagementList: Rolemanagement[],form : any) {

    for (let i = 0; i < rolemanagementList.length; i++) {
      rolemanagementList[i].DesignationId =+ form.value.designationId;
      rolemanagementList[i].IsActive = form.value.IsActive;

      rolemanagementList[i].CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
      rolemanagementList[i].EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
      rolemanagementList[i].EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
      rolemanagementList[i].SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
      // console.log( rolemanagementList[i])
    }

    let body = rolemanagementList;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.getBaseUrl() + 'api/Role/IUDList', body, { headers: headers });
  }

  // FetchRolemanagementList() {
  //   let body = null;
  //   const headers = new HttpHeaders();
  //   headers.set('Content-Type', 'application/json; charset=utf-8');
  //   return this.httpClient.post<any>(this.getBaseUrl() + 'api/Role/FetchList', body, { headers: headers });
  // }

  GetRolesList(){
 
    this.selectedRolemanagement = new Rolemanagement();
    this.selectedRolemanagement.DesignationId = 0;
    this.selectedRolemanagement.ListByDesignationId = false; // -- using to get Role management by designation Id
    this.selectedRolemanagement.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedRolemanagement.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedRolemanagement.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedRolemanagement.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = this.selectedRolemanagement;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() + 'api/Role/FetchList', body, {headers: headers });
  }

  GetRolesListbyId(designationId: any){

    this.selectedRolemanagement.DesignationId = designationId;
    this.selectedRolemanagement.ListByDesignationId = true; // -- using to get Role management by designation Id
    this.selectedRolemanagement.CompanyId = + JSON.parse(localStorage.getItem("EmployeeData"))["CompanyId"];
    this.selectedRolemanagement.EmployeeBranchId = + JSON.parse(localStorage.getItem("EmployeeData"))["BranchId"];
    this.selectedRolemanagement.EmployeeId = + JSON.parse(localStorage.getItem("EmployeeData"))["Id"];
    this.selectedRolemanagement.SaasId =  JSON.parse(localStorage.getItem("EmployeeData"))["SaasId"];
    let body = this.selectedRolemanagement;
    const headers = new HttpHeaders();
    headers.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>( this.getBaseUrl() + 'api/Role/FetchList', body, {headers: headers });
  }

}
